// Shared instruction overlay used across AR states.
// Renders a single line of text centered near the bottom of the AR viewport,
// behind a subtle translucent pill. Used for scanning, aim, tracking-lost, etc.

/**
 * Sets the instruction overlay content inside #ar-overlay-slot.
 * Pass null to clear (hide) the overlay.
 */
export function setInstruction(slot: HTMLElement, text: string | null): void {
  let el = slot.querySelector<HTMLElement>('.ar-instruction');
  if (!text) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('div');
    el.className = 'ar-instruction';
    slot.appendChild(el);
  }
  el.textContent = text;
}
